/* lkp2-fit.js - Lush Keepsake personaliser v2: framing and wording fixes (20/10/2026). Loaded last (snippets/lkp2-scripts).
   1) Whistle front (art whistle.plan-h): the whole whistle is in view (it was cut off on the right) and the
      dashed engraving box starts after the black band instead of touching it.
   2) Bar bracelets (art bar-bracelet-*): framed on the bar, so the engraving is shown at a readable size.
   3) Thin pieces (tie clips, bar bracelets) on phones: a shorter preview box, so there is no big empty space
      above and below the piece (html.lkp2-thin, CSS in assets/lkp2-look.css).
   4) Country outlines: if the place typed has no outline in our map list, a short note says we will check
      the shape and email if needed (the order can still go ahead).
   5) Two-country designs (country keychain, bar keychain, necklace, bracelet): always two outlines side by side,
      left and right, centred in the engraving area and each scaled to fill its half (a heart in each and a dashed
      line between). A country not typed yet shows its example (placeholder) so the layout is clear. */
(function () {
  'use strict';
  var L = window.LKP2, K = window.__lkp2k || {};
  if (!L || !L.P) return;
  var P = L.P;
  function art(ph) { return String((ph && ph.art) || ''); }

  /* ---- 1 + 2: framing ---- */
  var oVR = P.prototype.viewRect;
  P.prototype.viewRect = function (ph, W, H, A, mode) {
    var r = oVR.apply(this, arguments);
    if (!ph || mode === 'full' || !ph.isArt) return r;
    var a = art(ph), sw, sh, cx, cy;
    if (a === 'whistle.plan-h' && mode !== 'close') {
      /* from the key ring to the mouth end, centred on the engraving height */
      var x0 = 0.05 * W;
      sw = Math.max(r.w, W - x0); sh = sw / A;
      cy = (ph.zone ? ph.zone.y : 50) / 100 * H;
      return { x: Math.min(x0, W - sw), y: cy - sh / 2, w: sw, h: sh };
    }
    if (/^bar-bracelet/.test(a) && ph.zone && mode !== 'close') {
      /* the bar (with its end rings) fills the width */
      sw = Math.min(r.w, ph.zone.w / 100 * W * 1.5); sh = sw / A;
      if (sh < ph.zone.h / 100 * H * 3) { sh = ph.zone.h / 100 * H * 3; sw = sh * A; }
      cx = ph.zone.x / 100 * W; cy = ph.zone.y / 100 * H;
      return { x: cx - sw / 2, y: cy - sh / 2, w: sw, h: sh };
    }
    return r;
  };
  var oPhoto = P.prototype.photo;
  P.prototype.photo = function () {
    var ph = oPhoto.apply(this, arguments);
    if (ph && ph.zone && art(ph) === 'whistle.plan-h' && !ph.__lkFit) {
      ph.__lkFit = 1;
      ph.zone = Object.assign({}, ph.zone, { x: ph.zone.x + 1.4, w: ph.zone.w - 2.8 });
    }
    return ph;
  };

  /* ---- 3: thin pieces get a shorter preview box on phones ---- */
  function thin(x) {
    try {
      var fs = x.allFaces ? x.allFaces() : (x.cfg && x.cfg.faces) || [];
      if (!fs.length) return false;
      return fs.every(function (f) { var id = String((f.art && f.art.id) || ''); return /^(tie-clip|bar-bracelet)/.test(id); });
    } catch (e) { return false; }
  }
  function mark() {
    var el = document.querySelector('[data-lkp2]'), x = el && el.__lkp2;
    if (!x) return false;
    if (thin(x)) {
      document.documentElement.classList.add('lkp2-thin');
      if (x.drawStage) try { x.drawStage(); } catch (e) {}
    }
    return true;
  }

  /* ---- 4: country outline check ---- */
  var MSG = 'We don’t have an outline for that name yet. Please check the spelling, or carry on: we’ll check your country shape and email you if needed.';
  function mapIndex() {
    /* the personaliser loads the outline index itself as soon as a place is typed */
    return new Promise(function (res) {
      var n = 0;
      (function look() {
        var p = (K.MAPS || {})['lkm-index.json'];
        if (p && p.done) return res(p.done);
        if (p && p.then) return p.then(res, function () { res(null); });
        if (++n > 15) return res(null);
        setTimeout(look, 200);
      })();
    });
  }
  function note(inp, show) {
    var fld = inp.closest('.lkp2__field') || inp.parentNode, n = fld.querySelector('.lkp2-mapnote');
    if (!show) { if (n) n.hidden = true; return; }
    if (!n) { n = document.createElement('p'); n.className = 'lkp2-mapnote'; n.setAttribute('role', 'status'); n.textContent = MSG; inp.insertAdjacentElement('afterend', n); }
    n.hidden = false;
  }
  var t = null;
  function check(inp) {
    var v = (inp.value || '').trim();
    if (v.length < 3) { note(inp, false); return; }
    mapIndex().then(function (ix) {
      if (!ix || typeof K.mapFind !== 'function') return;
      if ((inp.value || '').trim() !== v) return;
      note(inp, !K.mapFind(ix, v));
    }).catch(function () {});
  }
  function isCountry(el) {
    if (!el || el.tagName !== 'INPUT' || !el.closest) return false;
    var fld = el.closest('.lkp2__field'); if (!fld) return false;
    var lab = fld.querySelector('label'); return !!lab && /\bcountry\b/i.test(lab.textContent || '');
  }
  document.addEventListener('input', function (e) { if (!isCountry(e.target)) return; var el = e.target; clearTimeout(t); t = setTimeout(function () { check(el); }, 500); });
  document.addEventListener('focusout', function (e) { if (isCountry(e.target)) check(e.target); });

  /* ---- 5: two countries side by side ---- */
  function pathBox(d) {
    var t = String(d || '').match(/[a-zA-Z]|-?\d*\.?\d+(?:e[-+]?\d+)?/g) || [], i = 0, c = '', x = 0, y = 0, sx = 0, sy = 0;
    var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, n = function () { return parseFloat(t[i++]); };
    function pt() { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    while (i < t.length) {
      if (/[a-zA-Z]/.test(t[i])) { c = t[i++]; if (c === 'z' || c === 'Z') { x = sx; y = sy; continue; } }
      if (c === 'm' || c === 'l') { x += n(); y += n(); if (c === 'm') { sx = x; sy = y; c = 'l'; } }
      else if (c === 'M' || c === 'L') { x = n(); y = n(); if (c === 'M') { sx = x; sy = y; c = 'L'; } }
      else if (c === 'h') x += n(); else if (c === 'H') x = n(); else if (c === 'v') y += n(); else if (c === 'V') y = n();
      else { i++; continue; }
      pt();
    }
    return x1 > x0 ? { x: x0, y: y0, w: x1 - x0, h: Math.max(1, y1 - y0) } : { x: 0, y: 0, w: 1000, h: 1000 };
  }
  var oMot = P.prototype.motifsOf;
  P.prototype.motifsOf = function (f, ph) {
    var out = oMot.apply(this, arguments);
    try {
      var V = this.vals(f), fields = this.fieldsOf(f);
      (ph && ph.motifs || []).forEach(function (m) {
        var ids = m.fields || [];
        if (!m.outline || ids.length !== 2) return;
        var hit = out.filter(function (o) { return o.outline && o.box === m.box; })[0];
        if (!hit || hit.outline.length !== 1) return;
        var places = ids.map(function (id) {
          var v = V[id] && String(V[id]).trim();
          if (v) return v;
          var fd = fields.filter(function (x) { return x.id === id; })[0];
          return fd && fd.placeholder ? String(fd.placeholder).replace(/^e\.g\.\s*/i, '') : '';
        });
        if (places[0] && places[1]) hit.outline = places;
      });
    } catch (e) {}
    return out;
  };
  var oDO = P.prototype.drawOutline;
  P.prototype.drawOutline = function (l, m, W, H, k, vr, pend, ghost) {
    if (!m || !m.outline || m.outline.length !== 2 || m.pins || !K.mapPlace) return oDO.apply(this, arguments);
    var me = this, items = [], wait = false;
    m.outline.forEach(function (t) {
      var r = K.mapPlace(me.artBase, t);
      if (r && r.pending) { wait = true; pend.push(r.pending.then(function () {}, function () {})); }
      items.push({ t: t, r: r && !r.pending ? r : null });
    });
    if (wait) return;
    var B = m.box, bx = B.x / 100 * W, by = B.y / 100 * H, bw = B.w / 100 * W, bh = B.h / 100 * H;
    var round = B.shape === 'ellipse' || Math.abs(bw - bh) < Math.max(bw, bh) * 0.25;
    var cw = bw * (round ? 0.4 : 0.44), ch = bh * (round ? 0.6 : 0.84), off = bw * (round ? 0.23 : 0.25);
    var cells = [[bx - off, by], [bx + off, by]];
    var D = K.D || {}, SF = (D.STYLE_FONTS && D.STYLE_FONTS.serif) || 'serif', hearts = [];
    l.save(); l.setTransform(k, 0, 0, k, -vr.x * k, -vr.y * k);
    if (m.ex && !ghost) l.globalAlpha = 0.35;
    items.forEach(function (it, i) {
      var c = cells[i];
      if (it.r) {
        var d = it.r.d && it.r.d.d ? it.r.d.d : it.r.d, bb = it.r.__bb || (it.r.__bb = pathBox(d)), s = Math.min(cw / bb.w, ch / bb.h);
        l.save(); l.translate(c[0] - (bb.x + bb.w / 2) * s, c[1] - (bb.y + bb.h / 2) * s); l.scale(s, s);
        l.lineJoin = 'round'; l.lineCap = 'round'; l.lineWidth = Math.max(6, 2.2 / s); l.strokeStyle = '#000';
        l.stroke(new Path2D(d)); l.restore();
      } else {
        l.font = '100px ' + SF; var tw = l.measureText(it.t).width / 100, fs = Math.min(ch * 0.22, cw * 0.9 / Math.max(0.1, tw));
        l.font = fs + 'px ' + SF; l.textAlign = 'center'; l.textBaseline = 'middle'; l.fillStyle = '#000'; l.fillText(it.t, c[0], c[1]);
      }
      hearts.push([c[0], c[1], Math.min(cw, ch) * 0.16]);
    });
    var a = hearts[0], b = hearts[1], mx = (a[0] + b[0]) / 2, my = Math.min(a[1], b[1]) - ch * 0.38;
    l.save(); l.strokeStyle = '#000'; l.lineWidth = Math.max(1, bh * 0.018); l.lineCap = 'round'; l.setLineDash([bh * 0.045, bh * 0.04]);
    l.beginPath(); l.moveTo(a[0] + a[2] * 0.55, a[1] - a[2] * 0.25); l.quadraticCurveTo(mx, my, b[0] - b[2] * 0.55, b[1] - b[2] * 0.25); l.stroke(); l.restore();
    hearts.forEach(function (h) {
      var x = h[0], y = h[1], s = h[2]; l.save(); l.fillStyle = '#000'; l.beginPath();
      l.moveTo(x, y + s * 0.42); l.bezierCurveTo(x - s * 0.62, y, x - s * 0.5, y - s * 0.48, x, y - s * 0.2); l.bezierCurveTo(x + s * 0.5, y - s * 0.48, x + s * 0.62, y, x, y + s * 0.42); l.fill(); l.restore();
    });
    l.restore();
  };

  function start() { if (mark()) return; var n = 0, iv = setInterval(function () { if (mark() || ++n > 20) clearInterval(iv); }, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
